import {
  Checkbox,
  Icon,
  Text,
  Timestamp,
  Tooltip,
} from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { SearchConversationEnriched } from 'lib-search-types';
import { ConversationStatus } from 'lib-shared-types-api';

import { AppLink } from 'components/appLink';
import { ConversationChip } from 'components/conversation/conversationChip';

import styles from './conversationTimelineDetailsItem.module.scss';

type ConversationTimelineDetailsItemProps = {
  conversation: SearchConversationEnriched;
  title: string | undefined;
  linkedTo: number | undefined;
  isCurrentConversation: boolean;
  isChecked: boolean;
  status: ConversationStatus | undefined;
  onCheck: (id: number) => void;
};

export const ConversationTimelineDetailsItem = ({
  conversation,
  title,
  linkedTo,
  isChecked,
  status,
  isCurrentConversation,
  onCheck,
}: ConversationTimelineDetailsItemProps): JSX.Element => {
  const { id, created_at, initial_channel, queue, linked_to } = conversation;
  const csidLink =
    linkedTo !== -1
      ? (linked_to?.split('_').at(0) ?? linkedTo?.toString())
      : undefined;
  const conversationStatus = status ?? conversation.status;

  const rootClass = classnames({
    [styles.root]: true,
    [styles.ownConversation]: isCurrentConversation,
  });

  return (
    <div className={rootClass}>
      <div className={styles.checkbox}>
        <Checkbox
          id={`${id}`}
          checked={isCurrentConversation || isChecked}
          disabled={isCurrentConversation || !!csidLink}
          onChange={() => onCheck(id)}
        />
      </div>

      <AppLink
        className={styles.content}
        path="/conversation/:csid"
        params={{ path: { csid: `${id}` } }}
      >
        <div className={styles.statusBar}>
          <ConversationChip
            csid={id}
            status={conversationStatus}
            channel={initial_channel}
          />

          {csidLink && (
            <Tooltip content={`Linked to #${csidLink}`}>
              <div className={styles.linkIcon}>
                <Icon name="link" />
              </div>
            </Tooltip>
          )}
        </div>

        <Text.Paragraph subdued as="span" variant="1" clamp={2} padding="100 0">
          {title}
        </Text.Paragraph>

        <div className={styles.contentDetails}>
          {queue && (
            <Text.Paragraph
              subdued
              as="span"
              variant="3"
              maxWidth="50%"
              wrap="nowrap"
            >
              <Tooltip content={queue.name}>{queue.name}</Tooltip>
            </Text.Paragraph>
          )}

          {created_at && (
            <Text.Paragraph subdued as="span" variant="3" wrap="nowrap">
              <Timestamp
                time={created_at}
                relative
                onClick={(_, e) => e.preventDefault()}
              />
            </Text.Paragraph>
          )}
        </div>
      </AppLink>
    </div>
  );
};
